interface AppUrls {
  adminApp: string;
  accountApp: string;
  ticketApp: string;
  indexApp: string;
  spaceApp: string;
  apiUrl: string;
}

interface Config {
  development: AppUrls;
  production: AppUrls;
}

const config: Config = {
  development: {
    adminApp: 'https://admin.blackadder.local:3004',
    indexApp: 'https://blackadder.local:3000',
    accountApp: 'https://account.blackadder.local:3001',
    ticketApp: 'https://ticket.blackadder.local:3002',
    spaceApp: 'https://space.blackadder.local:3003',
    apiUrl: 'https://api.blackadder.local:8890/api'
  },
  production: {
    adminApp: 'https://admin.blackadder.co.jp',
    accountApp: 'https://account.blackadder.co.jp',
    ticketApp: 'https://tickets.blackadder.co.jp',
    indexApp: 'https://blackadder.co.jp',
    spaceApp: 'https://space.blackadder.co.jp',
    apiUrl: 'https://blackadder.co.jp/api'
  }
};

const getEnvironment = () => {
  // NODE_ENVがproductionの場合は本番環境、それ以外は開発環境
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
};

export const getAppUrl = (appName: keyof Omit<AppUrls, 'apiUrl'>): string => {
  const env = getEnvironment();
  return config[env][appName];
};

export const getApiUrl = (): string => {
  const env = getEnvironment();
  return config[env].apiUrl;
};

export default config;
